import { algoliasearch } from 'algoliasearch';
import { SearchFilter, TenantListingCard } from '../../types/portal';

const APP_ID = import.meta.env.VITE_ALGOLIA_APP_ID || '';
const SEARCH_KEY = import.meta.env.VITE_ALGOLIA_SEARCH_KEY || '';
const INDEX_NAME = 'tenants';

// Cliente para busca
const client = APP_ID && SEARCH_KEY ? algoliasearch(APP_ID, SEARCH_KEY) : null;

export const algoliaService = {
  /**
   * Constrói a string de filtros para o Algolia
   */
  buildFilters(filters: SearchFilter): string {
    const algoliaFilters: string[] = [];

    if (filters.state) {
      algoliaFilters.push(`location.state:${filters.state.toUpperCase()}`);
    }

    if (filters.city) {
      algoliaFilters.push(`location.city:"${filters.city}"`);
    }

    if (filters.tenantTypes && filters.tenantTypes.length > 0) {
      const typesFilter = filters.tenantTypes.map(t => `tenantType:${t}`).join(' OR ');
      algoliaFilters.push(`(${typesFilter})`);
    }

    if (filters.categoryTags && filters.categoryTags.length > 0) {
      const tagsFilter = filters.categoryTags.map(t => `categoryTags:${t}`).join(' AND ');
      algoliaFilters.push(`(${tagsFilter})`);
    }

    if (filters.minRating) {
      algoliaFilters.push(`reviewStats.rating >= ${filters.minRating}`);
    }

    return algoliaFilters.join(' AND ');
  },

  /**
   * Realiza a busca no Algolia
   */
  async search(filters: SearchFilter): Promise<TenantListingCard[] | null> {
    if (!client) {
      console.warn('Algolia not configured. Falling back to Firestore.');
      return null;
    }

    try {
      const response = await client.search({
        requests: [
          {
            indexName: INDEX_NAME,
            query: filters.query || '',
            filters: this.buildFilters(filters),
            hitsPerPage: 20,
          }
        ]
      });

      // @ts-ignore
      const results = response.results[0];
      // @ts-ignore
      const hits = results.hits || [];

      return hits.map((hit: any) => ({
        id: hit.objectID,
        slug: hit.slug || hit.objectID,
        businessName: hit.businessName,
        tenantType: hit.tenantType,
        location: hit.location,
        shortDescription: hit.shortDescription,
        coverImage: hit.coverImage,
        highlights: hit.highlights || [],
        categoryTags: hit.categoryTags || [],
        verifiedBadge: hit.verifiedBadge || false,
        isFeatured: hit.isFeatured || false,
        reviewStats: hit.reviewStats || { rating: 0, count: 0 }
      }));
    } catch (error) {
      console.error('Algolia search error:', error);
      return null;
    }
  }
};
